import { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'
import TextField from '../../../FormLegacy/FormFieldsV2/TextField'
import InfiniteScroll from '../../../InfiniteScroll/InfiniteScroll'
import Avatar from '../../../../Avatar'
import Loader from '../../../Loader/Loader'
import {
  selectClients,
  selectStatusOfLoading,
  setLoadingState,
  selectStatusIsLoadedAll,
} from '../../../../reducers/clientsReducer'
import { getAssetLink } from '../../../../helpers/get-asset-link'

const ChatContactsWindowForWidget = ({
  isOpen,
  onClose,
  fetchContacts,
  isLoading,
  contacts,
  isLoadedAll,
  setLoadingState,
  onSelectAction,
}) => {
  const { t } = useTranslation(['chat'])
  const [isViewLoading, setViewLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [prevSearch, setPrevSearch] = useState('')
  const timeout = useRef(null)
  const debounceFn = debounce(fetchContacts, 1000)

  const onSelectOption = (userData) => {
    setViewLoading(true)
    onSelectAction(userData)
  }

  useEffect(() => {
    if (prevSearch !== search) {
      window.addEventListener('keydown', debounceFn(search))
    }
    setPrevSearch(search)
    return () => {
      window.removeEventListener('keydown', debounceFn)
    }
  }, [search])

  useEffect(() => {
    setSearch('')
    setViewLoading(false)
  }, [isOpen])

  useEffect(() => {
    fetchContacts(search, false)
    return () => {
      if (timeout.current) clearTimeout(timeout.current)
    }
  }, [])

  if (!isOpen) return null
  return (
    <div className="search-select-window-container">
      <div className="search-select-window-background" />
      <div className="search-select-window-content-container">
        <div className="navbar-part">
          <h1>{t('chat:widget.conversationWith')}</h1>
          {!isViewLoading && (
            <div className="close-button" onClick={onClose}>
              <Icon icon="cross" />
            </div>
          )}
        </div>
        {isViewLoading && (
          <div className="loader-wrapper">
            <Loader />
          </div>
        )}
        <TextField
          maxLength="50"
          name="searchInput"
          placeholder={t('chat:searchAndSelectWindow.searchPeople')}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value)
            setLoadingState(true)
          }}
        />
        <div className="results-part-infinity">
          {isLoading ? (
            <div>{t('chat:chatContactsWindow.loading')}</div>
          ) : contacts.length ? (
            <InfiniteScroll
              data={contacts}
              renderItem={(item, idx) => (
                <div key={idx} className="user-option" onClick={() => onSelectOption(item.user)}>
                  <Avatar size="big">
                    <img
                      src={getAssetLink({ path: 'chitown-avatar/avatar', file: item.user.avatar })}
                      alt={''}
                    />
                  </Avatar>
                  {`${item.user.firstName} ${item.user.lastName}`}
                </div>
              )}
              onEndReached={() => fetchContacts(search, true)}
              style={{ height: '100%', paddingRight: '12px' }}
              isLoadedAll={isLoadedAll}
            />
          ) : (
            <div>{t('chat:searchAndSelectWindow.noResults')}</div>
          )}
        </div>
      </div>
    </div>
  )
}

ChatContactsWindowForWidget.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  contacts: PropTypes.array,
  fetchContacts: PropTypes.func,
  isLoading: PropTypes.bool,
  setLoadingState: PropTypes.func,
  isLoadedAll: PropTypes.bool,
  onSelectAction: PropTypes.func,
}

export default connect(
  (state) => {
    return {
      contacts: selectClients(state),
      isLoading: selectStatusOfLoading(state),
      isLoadedAll: selectStatusIsLoadedAll(state),
    }
  },
  {
    setLoadingState,
  },
)(ChatContactsWindowForWidget)
